webpackJsonp([4,5],{

/***/ "./src/components/Features.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _typography = __webpack_require__("./src/utils/typography.js");
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var intersperse = function intersperse(items, fn) {
	  return items.reduce(function (items, item, i) {
	    return i === 0 ? [item] : [].concat(_toConsumableArray(items), [fn(i), item]);
	  }, []);
	};
	
	var Features = function (_React$Component) {
	  _inherits(Features, _React$Component);
	
	  function Features() {
	    _classCallCheck(this, Features);
	
	    return _possibleConstructorReturn(this, (Features.__proto__ || Object.getPrototypeOf(Features)).apply(this, arguments));
	  }
	
	  _createClass(Features, [{
	    key: "render",
	    value: function render() {
	      var items = this.props.features.map(function (_ref) {
	        var title = _ref.title,
	            description = _ref.description,
	            action = _ref.action,
	            url = _ref.url;
	        return Glamor.createElement(
	          "div",
	          { css: styles.feature, key: url },
	          Glamor.createElement(
	            "h4",
	            { css: styles.title },
	            title
	          ),
	          Glamor.createElement(
	            "div",
	            { css: styles.description },
	            description
	          ),
	          Glamor.createElement(
	            "div",
	            { css: { marginTop: 'auto' } },
	            Glamor.createElement(
	              _gatsbyLink2.default,
	              { css: styles.button, to: url },
	              action
	            )
	          )
	        );
	      });
	
	      return Glamor.createElement(
	        "div",
	        { css: styles.container },
	        intersperse(items, function (key) {
	          return Glamor.createElement("div", { key: key, css: styles.divider });
	        })
	      );
	    }
	  }]);
	
	  return Features;
	}(_react2.default.Component);
	
	exports.default = Features;
	
	
	var accent = '#db4d3f';
	
	var styles = {
	  container: {
	    flexDirection: 'row',
	    '@media(max-width: 900px)': {
	      flexDirection: 'column'
	    }
	  },
	  feature: {
	    flex: 1,
	    alignItems: 'center',
	    padding: 38
	  },
	  divider: {
	    flexBasis: 1,
	    backgroundColor: _colors.dividerLine,
	    margin: '30px 0',
	    '@media(max-width: 900px)': {
	      margin: 0
	    }
	  },
	
	  button: {
	    fontFamily: (0, _typography.headerFontFamily)(),
	    border: '1px solid currentColor',
	    backgroundColor: 'transparent',
	    borderRadius: 5,
	    padding: '5px 15px',
	    textDecoration: 'none',
	    color: 'currentColor',
	    marginTop: '1em',
	    fontSize: '.9em'
	  },
	
	  title: {
	    marginBottom: '.5em',
	    textAlign: 'center'
	  },
	
	  description: {
	    fontFamily: (0, _typography.headerFontFamily)(),
	    fontSize: 16,
	    lineHeight: 1.6,
	    textAlign: 'center',
	    maxWidth: 300
	  }
	};
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ }),

/***/ "./src/images/reason_300.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/reason_300.5d19cfa6.png";

/***/ }),

/***/ "./src/pages/community/example-screenshots/hacker-news.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hacker-news.df4de52a.png";

/***/ }),

/***/ "./src/pages/community/example-screenshots/llama-snake.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/llama-snake.58b4c039.png";

/***/ }),

/***/ "./src/pages/community/example-screenshots/mareo.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mareo.926d7c31.png";

/***/ }),

/***/ "./src/pages/community/example-screenshots/reason-maze.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/reason-maze.0fee349e.png";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/chenglou/Github/reasonml.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"add-module-exports\",\"add-module-exports\",\"transform-object-assign\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"babel-plugin-glamor\"],\"presets\":[\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-env/lib/index.js\",\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/community/examples.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var examples = [{
	  title: 'Reason Maze',
	  url: 'https://github.com/jaredly/reason-maze',
	  img: __webpack_require__("./src/pages/community/example-screenshots/reason-maze.png")
	}, {
	  title: 'Mareo: Mario + Reason',
	  url: 'https://github.com/reasonml-community/Mareo',
	  img: __webpack_require__("./src/pages/community/example-screenshots/mareo.png")
	}, {
	  title: 'ReasonReact Hacker News',
	  url: 'https://github.com/reasonml-community/reason-react-hacker-news',
	  img: __webpack_require__("./src/pages/community/example-screenshots/hacker-news.png")
	}, {
	  title: 'Reason snake',
	  url: 'https://github.com/rdavison/llama-snake/tree/master/websnake',
	  img: __webpack_require__("./src/pages/community/example-screenshots/llama-snake.png")
	}];
	
	var Examples = function (_React$Component) {
	  _inherits(Examples, _React$Component);
	
	  function Examples() {
	    _classCallCheck(this, Examples);
	
	    return _possibleConstructorReturn(this, (Examples.__proto__ || Object.getPrototypeOf(Examples)).apply(this, arguments));
	  }
	
	  _createClass(Examples, [{
	    key: 'render',
	    value: function render() {
	      return Glamor.createElement(
	        'div',
	        { css: styles.container },
	        examples.map(function (_ref, index) {
	          var title = _ref.title,
	              url = _ref.url,
	              img = _ref.img;
	          return Glamor.createElement(
	            'a',
	            { key: index, href: url, css: styles.link },
	            Glamor.createElement('img', { src: img, css: styles.img, role: 'presentation' }),
	            Glamor.createElement(
	              'span',
	              { css: styles.title },
	              title
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return Examples;
	}(_react2.default.Component);
	
	exports.default = Examples;
	
	
	var styles = {
	  container: {
	    display: 'flex',
	    flexDirection: 'row',
	    flexWrap: 'wrap'
	  },
	  link: {
	    display: 'flex',
	    alignItems: 'center',
	    margin: 10,
	    flexDirection: 'column',
	    textDecoration: 'none',
	    color: 'currentColor',
	    ':hover': {
	      textDecoration: 'underline'
	    }
	  },
	  img: {
	    width: 250,
	    height: 250,
	    marginBottom: .5
	  },
	  title: {}
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/chenglou/Github/reasonml.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"add-module-exports\",\"add-module-exports\",\"transform-object-assign\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"babel-plugin-glamor\"],\"presets\":[\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-env/lib/index.js\",\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _examples = __webpack_require__("./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/chenglou/Github/reasonml.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"add-module-exports\",\"add-module-exports\",\"transform-object-assign\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"babel-plugin-glamor\"],\"presets\":[\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-env/lib/index.js\",\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/community/examples.js");
	
	var _examples2 = _interopRequireDefault(_examples);
	
	var _Header = __webpack_require__("./src/components/Header.js");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Features = __webpack_require__("./src/components/Features.js");
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Section = __webpack_require__("./src/components/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _reason_ = __webpack_require__("./src/images/reason_300.png");
	
	var _reason_2 = _interopRequireDefault(_reason_);
	
	var _typography = __webpack_require__("./src/utils/typography.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var features = [{
	  title: 'Types without hassle',
	  description: 'Powerful, safe type inference means you rarely have to annotate types, but everything gets checked for you.',
	  action: 'Learn about types',
	  url: '/guide/language/type/'
	},
	// {
	//   title: 'Web or Native', // 😢 not ready yet
	//   description: 'Write your frontend, backend, and build tools all in the same language -- without compromising on speed.',
	//   action: 'Native quickstart',
	//   url: '/guide/native/quickstart/',
	// },
	{
	  title: 'Easy JavaScript interop',
	  description: "Use packages from NPM/Yarn with minimum hassle, or even drop in a snippet of raw JavaScript while you're learning!",
	  action: 'Learn about interop',
	  url: '/guide/javascript/interop/'
	}, {
	  title: 'Flexible & Fun',
	  description: 'Make websites, animations, games, servers, cli tools, and more! Take a look at these examples to get inspired.',
	  action: 'See examples',
	  url: '/community/examples'
	}];
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).apply(this, arguments));
	  }
	
	  _createClass(Index, [{
	    key: 'render',
	    value: function render() {
	      var _props$data = this.props.data,
	          mainExample = _props$data.mainExample,
	          jsquickstart = _props$data.jsquickstart,
	          examples = _props$data.examples;
	
	      return Glamor.createElement(
	        'div',
	        { css: styles.container },
	        Glamor.createElement(_reactHelmet2.default, { title: 'Reason' }),
	        Glamor.createElement(
	          _Section2.default,
	          { backgroundColor: _colors.gray },
	          Glamor.createElement(_Header2.default, null),
	          Glamor.createElement(
	            'div',
	            { css: { alignItems: 'center' } },
	            Glamor.createElement('img', { src: _reason_2.default, css: styles.logo, role: 'presentation' }),
	            Glamor.createElement(
	              'div',
	              { css: styles.frontAndCenter },
	              Glamor.createElement('div', { css: styles.mainExample,
	                dangerouslySetInnerHTML: {
	                  __html: mainExample.childMarkdownRemark.html
	                }
	              }),
	              Glamor.createElement(
	                'p',
	                { css: styles.description },
	                'Reason lets you write simple, fast and quality type safe code while leveraging both the JavaScript & OCaml ecosystems.'
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { css: styles.buttonGroup },
	              Glamor.createElement(
	                _gatsbyLink2.default,
	                { to: '/try', css: [styles.button, styles.actionButton] },
	                'Try online'
	              ),
	              Glamor.createElement(
	                _gatsbyLink2.default,
	                { to: '/guide/what-and-why', css: styles.button },
	                'Learn more'
	              )
	            )
	          ),
	          Glamor.createElement(
	            'div',
	            { css: styles.features },
	            Glamor.createElement(
	              'div',
	              { css: [styles.content] },
	              Glamor.createElement('div', { css: styles.featuresDivider }),
	              Glamor.createElement(_Features2.default, { features: features })
	            )
	          )
	        ),
	        Glamor.createElement(
	          _Section2.default,
	          { css: [styles.quickstarts, styles.twoColumn] },
	          Glamor.createElement(
	            'div',
	            { css: styles.column },
	            Glamor.createElement(
	              'h3',
	              { css: styles.columnHeader },
	              'JavaScript Quick Start'
	            ),
	            Glamor.createElement('div', {
	              css: styles.jsquickstart,
	              dangerouslySetInnerHTML: {
	                __html: jsquickstart.childMarkdownRemark.html
	              }
	            })
	          ),
	          Glamor.createElement(
	            'div',
	            { css: styles.column },
	            Glamor.createElement(
	              'h3',
	              { css: styles.columnHeader },
	              'Examples'
	            ),
	            Glamor.createElement(_examples2.default, null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	var styles = {
	  container: {},
	  inner: {},
	
	  header: {
	    backgroundColor: _colors.gray,
	    alignItems: 'center'
	  },
	
	  twoColumn: {
	    flexDirection: 'row',
	    '@media(max-width: 800px)': {
	      flexDirection: 'column'
	    }
	  },
	
	  column: {
	    flexGrow: 1,
	    flexBasis: 0,
	    flexShrink: 1,
	    margin: '0 20px',
	    minWidth: 0,
	    '@media(max-width: 800px)': {
	      flexBasis: 'auto'
	    }
	  },
	
	  columnHeader: {
	    alignSelf: 'center'
	  },
	
	  frontAndCenter: {
	    flexDirection: 'row',
	    alignItems: 'center',
	    margin: '2rem',
	    '@media(max-width: 950px)': {
	      flexDirection: 'column'
	    }
	  },
	
	  description: {
	    maxWidth: 600,
	    fontWeight: 200,
	    fontSize: '1.1em',
	    lineHeight: '1.5em',
	    textAlign: 'center',
	    textShadow: '0px 1px #f4f2f2',
	    padding: '0.8em',
	    marginBottom: 0,
	    fontFamily: (0, _typography.headerFontFamily)(),
	    '@media(min-width: 800px)': {
	      fontSize: '1.5em'
	    }
	  },
	  content: {
	    maxWidth: 1270,
	    alignSelf: 'center'
	  },
	
	  mainExample: {
	    '& .hljs': {
	      background: 'transparent',
	      border: 'none',
	      marginBottom: 0
	    }
	  },
	
	  button: {
	    fontFamily: (0, _typography.headerFontFamily)(),
	    textDecoration: 'none',
	    border: '1px solid currentColor',
	    padding: '8px 34px',
	    color: 'currentColor',
	    borderRadius: 5,
	    margin: 10,
	    textAlign: 'center'
	  },
	
	  actionButton: {
	    border: 'none',
	    background: _colors.accent,
	    color: 'white'
	  },
	
	  buttonGroup: {
	    flexDirection: 'row',
	    marginBottom: '3rem',
	    '@media(max-width: 340px)': {
	      flexDirection: 'column',
	      width: '80%'
	    }
	  },
	
	  featuresDivider: {
	    height: 1,
	    backgroundColor: '#d6d4d4'
	  },
	  features: {
	    // backgroundColor: '#d0d0d0',
	    backgroundColor: '#f6f4f4'
	  },
	
	  quickstarts: {
	    backgroundColor: 'white',
	    padding: 30
	  },
	
	  // please keep in sync with guide.css's markdown-content selectors
	  jsquickstart: {
	    '& a': {
	      color: _colors.accent,
	      textDecoration: 'none'
	    },
	    '& a:hover': {
	      textDecoration: 'underline'
	    },
	    '& a:visited': {
	      color: '#b13c2e'
	    }
	  },
	
	  logo: {
	    maxWidth: 300,
	    width: '80%'
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-index-js-683772e619f257f2953c.js